@if (helpPanelService.dataExistsForPage$ | async) {
  <div
    class="hidden sm:block"
    >
    <div style="min-height: 10px"></div>
    @if (!(helpPanelService.helpPanelOpen$ | async)) {
      <mat-icon
        style="color: grey; cursor: pointer"
        (click)="toggleOpenHelpPanel()"
      >help</mat-icon>
    }
  </div>
}
